import { render, staticRenderFns } from "./ExpenseItems.vue?vue&type=template&id=84545c3a&scoped=true"
import script from "./ExpenseItems.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpenseItems.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ExpenseItems.vue?vue&type=style&index=0&id=84545c3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84545c3a",
  null
  
)

export default component.exports